import {Component, OnInit} from "@angular/core";
import {select, Store} from "@ngrx/store";
import * as fromQuote from '../../reducers/index';
import * as fromLayout from '../../../core/reducers/layout.reducer';
import {Product} from "src/app/products/models/product";
import {Observable, tap} from 'rxjs';
import {Quote} from "../../model/quote";
import * as fromAuth from '../../../user/reducers';
import {getIsQuoteListOpen} from '../../../reducers';
import * as fromProduct from '../../../products/reducers';
import {QuoteBarItem} from "../../model/quote-bar-item";
import {load} from "../../actions/quotes.actions"

@Component({
    selector: 'app-quotes-nav',
    templateUrl: './quote-nav.component.html',
    styleUrls: ['./quote-nav.component.scss']
})

export class QuoteSideNavComponent implements OnInit{
    addToQuoteMenu$: Observable<boolean>;
    createNewQuote$: Observable<boolean>;
    chooseQuote$: Observable<boolean>;
    chosenQuote$: Observable<Quote>;
    isLoading$: Observable<boolean>;
    isLoggedIn$: Observable<boolean>;
    isQuoteListOpen$: Observable<boolean>;
    selectQuote: boolean = false;
    selectedQuote$: Observable<QuoteBarItem>;
    quotes$: Observable<Quote[]>;
    quoteListMenu$: Observable<boolean>;
    product$: Observable<Product>;
    selectedQuantity$: Observable<number>;
    quoteOrderComplete$: Observable<boolean>;

    constructor(private store: Store<fromQuote.State>, private productStore: Store<fromProduct.State>) {}

    ngOnInit(): void {
        this.quotes$ = this.store.pipe(select(fromQuote.getQuotesArray));
        this.addToQuoteMenu$ = this.store.pipe(select(fromQuote.getAddToQuoteMenu));
        this.createNewQuote$ = this.store.pipe(select(fromQuote.getCreateNewQuote));
        this.chooseQuote$ = this.store.pipe(select(fromQuote.getChooseQuote));
        this.chosenQuote$ = this.store.pipe(select(fromQuote.getChosenQuote));
        this.isLoading$ = this.store.pipe(select(fromQuote.getIsPending));
        this.isLoggedIn$ = this.store.pipe(select(fromAuth.getIsLoggedIn));
        this.isQuoteListOpen$ = this.store.pipe(select(getIsQuoteListOpen));
        this.quoteListMenu$ = this.store.pipe(select(fromQuote.getQuoteListMenu));
        this.product$ = this.productStore.pipe(select(fromProduct.getSelectedProduct));
        this.selectedQuantity$ = this.store.pipe(select(fromProduct.getSelectedQuantity));
        this.quoteOrderComplete$ = this.store.pipe(select(fromQuote.getQuoteOrderComplete));
        this.selectedQuote$ = this.store.pipe(select(fromQuote.getSelectedQuoteBarItem));
        this.store.dispatch(load());


        console.log(this.chosenQuote$.subscribe(v => console.log("Chosen quote", v)))
    }
}
